import * as React from 'react';

import { AnalyticsContext, IAnalyticsContext } from '../../utils/analyticsContext';
import { INewbuildingSummaryCellValue } from '../../types/newbuildingsCompare';
import { MapModalHeader } from '../../components/MapModal/parts';
import { NewbuildingCallButton } from '../NewbuildingCallButton';
import { TSellerType } from '../NewbuildingCallButton/tracking';
import { NewbuildingChatButton } from '../NewbuildingChatButton';
import { NewbuildingFavoriteButton } from '../NewbuildingFavoriteButton';

/** Кнопки в шапке карты шлют события блока инфраструктуры, а не таблицы сравнения. */
export const INFRASTRUCTURE_ANALYTICS_CONTEXT: IAnalyticsContext = { placement: 'infrastructure' };

export interface IDistrictInfrastructureMapHeaderContainerProps {
  newbuilding?: INewbuildingSummaryCellValue;
  title: string;
}

/**
 * Шапка карты района: заголовок и те же кнопки контактов, что в полноэкранной галерее.
 * Кнопки собираются здесь, потому что каждая из них — контейнер со своим состоянием.
 */
export function DistrictInfrastructureMapHeaderContainer({
  newbuilding,
  title,
}: IDistrictInfrastructureMapHeaderContainerProps): React.JSX.Element {
  const hasChat = Boolean(
    newbuilding && [...newbuilding.builders, ...newbuilding.sellers].some(contact => contact.chat?.enabled),
  );
  const sellerType: TSellerType = newbuilding && newbuilding.builders.length > 0 ? 'builders' : 'agents';

  return (
    <MapModalHeader
      buttons={
        newbuilding && (
          <AnalyticsContext.Provider value={INFRASTRUCTURE_ANALYTICS_CONTEXT}>
            <NewbuildingCallButton
              builders={newbuilding.builders}
              newbuildingId={newbuilding.id}
              sellers={newbuilding.sellers}
              showPhoneButtonIcon={true}
              singlePhoneButtonText="Контакты застройщика"
              size="M"
              url={newbuilding.fullUrl}
            />
            {hasChat && (
              <NewbuildingChatButton
                builders={newbuilding.builders}
                newbuildingId={newbuilding.id}
                sellers={newbuilding.sellers}
                size="M"
                url={newbuilding.fullUrl}
              />
            )}
            <NewbuildingFavoriteButton
              gaLabel={newbuilding.fullUrl}
              isFavorite={newbuilding.isFavorite}
              newbuildingId={newbuilding.id}
              sellerType={sellerType}
              url={newbuilding.fullUrl}
              variant="button"
            />
          </AnalyticsContext.Provider>
        )
      }
      testId="district-infrastructure-map-header"
      title={title}
    />
  );
}
